var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isChile)?_c('TermsOfUseChile'):_c('TermsOfUseDefault')
}
var staticRenderFns = []

export { render, staticRenderFns }